import { ReactNode } from "react";
import { CSSProperties } from "styled-components";

type Props = {
  children: ReactNode;
  style?: CSSProperties;
};

export const ShowEmpty = (props: Props) => {
  return <span style={{ ...props.style }}> {props.children}</span>;
};
